import ReactECharts from 'echarts-for-react';
import 'echarts-gl';
import data from "./data.json"
import { useEffect, useState } from 'react';
import { Button, Flex, ColorPicker } from 'antd';

import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';



const PointCloud = () => {

  const [searchParams, setSearchParams] = useSearchParams();
  const designResId = searchParams.get("id")

  const [startList, setStartList] = useState([])
  const [itemColor, setItemColor] = useState('#FF4500')
  const navigate = useNavigate()

  const toDisplayDetail = () => {
    console.log("designResId:", designResId);

    navigate(`/DesignResDetail?id=${designResId}`)
  }

  const resetColor = () => {
    setItemColor('#000000')
  }

  const changeColorRed = (e) => {
    let r = e.metaColor.r
    let g = e.metaColor.g
    let b = e.metaColor.b
    setItemColor(`#${[r, g, b].map(c => c.toString(16).padStart(2, '0')).join('')}`);
  }

  useEffect(() => {
    const props = data.map(item => item.start)
    setStartList(props)
  }, [])

  const option = {
    grid3D: {},
    xAxis3D: { type: 'value' },
    yAxis3D: { type: 'value' },
    zAxis3D: { type: 'value' },
    series: [{
      type: 'scatter3D',
      data: startList,
      symbolSize: 10,
      itemStyle: { color: itemColor }
    }]
  }
  return <Flex vertical>
    <Flex>
      <Button type='primary' onClick={toDisplayDetail} style={{ width: 200 }}>返回</Button>
      <Button onClick={resetColor} style={{ width: 200, marginLeft: 20 }}>颜色重置</Button>
      <ColorPicker defaultValue="#1677ff" size="small" onChange={changeColorRed} style={{ marginLeft: 20 }} />
    </Flex>
    <ReactECharts option={option} style={{ height: '600px' }} />
  </Flex>
}

export default PointCloud;